module.exports = __webpack_public_path__ + "img/interests1.b4d2fbf4.svg";